import React from 'react';
import HeadingCard from 'components/Card/HeadingCard';
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { useHistory } from 'react-router-dom';

const ReportWidget: React.FC = () => {
    const history = useHistory();

    return (
        <HeadingCard title="Reports">
            <List component="nav" aria-label="report folders">
                <ListItem button onClick={() => history.push('/staff/reports/razorpay-aggregated')}>
                    <ListItemIcon>
                        <AssessmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Razorpay Aggregated Payments" secondary="View daily aggregated payments" />
                </ListItem>
            </List>
        </HeadingCard>
    );
};

export default ReportWidget;
